import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpCall } from '../services/httpcall.service';
import { localStorageConstants } from 'src/consts/local-storage-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<boolean>;
  public currentUser: Observable<boolean>;
  public checkApproverUserSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private currentTokenSubject: BehaviorSubject<string>;
  public currentToken: Observable<string>;

  constructor(private httpClient: HttpClient, private httpCall: HttpCall) {
    const logout = localStorage.getItem(localStorageConstants.LOGOUT) ?? 'true';
    this.currentUserSubject = new BehaviorSubject<boolean>(logout == 'true');
    this.currentUser = this.currentUserSubject.asObservable();
    this.checkApproverUserSubject = new BehaviorSubject<boolean>(true);
    const token = localStorage.getItem(localStorageConstants.INVOICE_TOKEN) ?? '';
    this.currentTokenSubject = new BehaviorSubject<string>(token);
    this.currentToken = this.currentTokenSubject.asObservable();
  }

  public get currentUserValue(): boolean {
    return this.currentUserSubject.value;
  }
  public get checkApproverUserValue(): boolean {
    return this.checkApproverUserSubject.value;
  }

  changeLoginValue(value: boolean) {
    this.currentUserSubject.next(value);
  }

  public get currentTokenValue(): string {
    return this.currentTokenSubject.value;
  }

  changeTokenValue(value: string) {
    this.currentTokenSubject.next(value);
  }

  encription(req: any) {
    const secretKey = 'krunal1#007';

    // Generate a random IV (Initialization Vector)
    const iv = CryptoJS.lib.WordArray.random(16);

    // Encrypt the data using AES-256-CBC algorithm
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(req), secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return encryptedData;

  }

  getHex() {
    const iv = CryptoJS.lib.WordArray.random(16);
    const ivHex = iv.toString(CryptoJS.enc.Hex);
    return ivHex;
  }
}
